export const APP_MESSAGES = {
  DRAIVN_COPYRIGHT: "© {year} Draivn Corp.",
};
